import { render, staticRenderFns } from "./Devize_draft.vue?vue&type=template&id=77704273&scoped=true&"
import script from "./Devize_draft.vue?vue&type=script&lang=js&"
export * from "./Devize_draft.vue?vue&type=script&lang=js&"
import style0 from "./Devize_draft.vue?vue&type=style&index=0&id=77704273&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77704273",
  null
  
)

export default component.exports